import $ from "jquery";
import {productSwiper} from "./swiper";

var lazyLoad = {

    init: function() {
        $(".ajax-lazyload").each(function() {
            const url = $(this).data("url");
            const dataSwiper = $(this).data("swiper") === true;
            lazyLoad.load(url, $(this), dataSwiper);
        });
    },

    load: function (url, $parent, dataSwiper) {

        $parent.append("<div class='loader'></div>").addClass('loading');

        let request = $.get(url, 'json');

        request.done(function (response) {
            if(response.success) {
                const cleanHtml = $("<div>").append(response.data).html();
                const $content = $(cleanHtml).hide();
                $parent.append($content);
                const $loadedContent = $parent.find(".container");

                $parent.find(".loader").fadeOut(400, function() {
                    $(this).remove();
                    $content.fadeIn(500);
                    if(dataSwiper) {
                        productSwiper.createSwiperOnContainer($loadedContent);
                    }
                    $parent.removeClass('loading');

                });
            } else {
                console.log('error', response.error);
            }
        }).fail(function (jqXHR, textStatus) {
            console.log('error', jqXHR, textStatus);

        })
    },
};

$(function (){
    lazyLoad.init();
});